import { css } from '@emotion/react';

import theme from '@/styles/theme';

/** 본문 최대 너비만 (탭·내부 래퍼용) */
export const pageContentWidth = css`
	max-width: ${theme.scale.contentMaxWidth};
	width: 100%;
	margin-left: auto;
	margin-right: auto;
`;

/** 서브 페이지 섹션 — 가로 너비 + 상하·좌우 패딩 통일 */
export const pageSectionLayout = css`
	${pageContentWidth}
	padding-top: ${theme.scale.sectionPaddingY};
	padding-bottom: ${theme.scale.sectionPaddingY};
	padding-left: 0;
	padding-right: 0;

	@media screen and (max-width: ${theme.scale.contentBreakpoint}) {
		padding-left: ${theme.scale.contentPaddingX};
		padding-right: ${theme.scale.contentPaddingX};
	}

	@media screen and (max-width: 900px) {
		padding-top: ${theme.scale.sectionPaddingYMobile};
		padding-bottom: ${theme.scale.sectionPaddingYMobile};
	}
`;
